import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class AgentRequirementStatusCtrl implements IController {

  status: any;

  private requirementStatus: any;

  constructor() {
  }

  $onInit() {}

  $onChanges(changes) {
    if (changes.status) {
      if (_.isEqual(this.status, 'Awaiting')) {
        this.requirementStatus = {'background': '#616161'};
      }
      if (_.isEqual(this.status, 'Pending')) {
        this.requirementStatus = {'background': '#E65100'};
      }
      if (_.isEqual(this.status, 'Rejected')) {
        this.requirementStatus = {'background': '#EF5350'};
      }
      if (_.isEqual(this.status, 'Approved')) {
        this.requirementStatus = {'background': '#81C784'};
      }
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentRequirementStatus', {
    bindings: {
      status: '<'
    },
    template: require('./agent-requirement-status.html').default,
    controller: AgentRequirementStatusCtrl
  });
